import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { useEditCtaContext } from "../../../../../../context/EditCtaContext";
import ImageUpload from "./ImageUpload";

const BackgroundGroup = () => {
  const { formData, setFormData, getCurrentStep } = useEditCtaContext();

  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleChange = (field, value) => {
    // onDataChange({ ...formData, [field]: value });
    setFormData({ ...formData, [field]: value });
  };

  const handleColorChange = (color) => {
    // onDataChange({ ...formData, titleColor: color.hex });
    setFormData({ ...formData, backgroundColor: color.hex });
  };

  return (
    <div className="flex flex-col px-6 pb-6 min-h-[400px]">
      {/* Step Header */}
      <div className="flex flex-col pt-4 mb-12">
        <h2 className="text-white text-2xl font-semibold leading-[30px] tracking-[-0.15px] mb-0">
          Step {getCurrentStep() + 1}
        </h2>
        <p className="text-white text-xl font-medium leading-6">
          Pick your background
        </p>
      </div>

      {/* Form Fields */}
      <div className="flex flex-col gap-3">
        {/* Font Size Selector */}
        <div className="flex flex-col gap-1">
          <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
            Option
          </label>
          <div className="relative mb-4">
            <select
              value={formData.backgroundType}
              onChange={(e) => handleChange("backgroundType", e.target.value)}
              className="h-9 w-full px-3 py-2 rounded border border-[#DCDFE3] bg-white text-base text-[#758195] appearance-none focus:outline-none focus:ring-1 focus:ring-purple-500"
            >
              <option value={"color"}>Color</option>
              <option value={"image"}>Image</option>
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="8" height="22" viewBox="0 0 8 22" fill="none">
                <path
                  d="M0 7.13503L3.84664 0.310547L8 7.11489L0 7.13503Z"
                  fill="#231F20"
                />
                <path
                  d="M8 14.4863L4.15336 21.3108L0 14.5066L8 14.4863Z"
                  fill="#231F20"
                />
              </svg>
            </div>
          </div>
          {formData.backgroundType === "color" ? (
            <div className="relative">
              <div
                onClick={() => setShowColorPicker(!showColorPicker)}
                className="w-11 h-11 mx-auto rounded border border-white cursor-pointer"
                style={{ backgroundColor: formData.backgroundColor }}
              />
              {showColorPicker && (
                <div className="absolute z-10 -mt-36">
                  <div
                    className="fixed inset-0"
                    onClick={() => setShowColorPicker(false)}
                  />
                  <SketchPicker
                    color={formData.backgroundColor}
                    onChange={handleColorChange}
                  />
                </div>
              )}
            </div>
          ) : (
            <ImageUpload />
          )}
        </div>
      </div>
    </div>
  );
};

export default BackgroundGroup;
